export enum ToastConstants {
  SET_TOAST = 'SET_TOAST',
  CLEAR_TOAST = 'CLEAR_TOAST',
}
